import "./style/app.scss";
import { createApp } from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify.js";
import router from "./router";
import store from "./store/store";
import Vue3Tour from 'vue3-tour';
import 'vue3-tour/dist/vue3-tour.css'

const app = createApp(App);

app.use(router);
app.use(vuetify);
app.use(store);
app.use(Vue3Tour);


app.config.globalProperties.$currency = (value) => {
    return '$' + parseFloat(value).toFixed(2);
};

app.config.globalProperties.$capitalize = (value) => {
    return value.charAt(0).toUpperCase() + value.slice(1);
};
app.mount('#app');
export default app;